import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '40px 20px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto', background: 'white', borderRadius: 12, padding: '48px 56px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>

        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 32, textDecoration: 'none', color: '#64748b', fontSize: '0.88rem' }}>
          ← Back to ApplyAI
        </Link>

        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>Privacy Policy</h1>
        <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: 40 }}>Last updated: April 29, 2026</p>

        <section style={sectionStyle}>
          <h2 style={h2Style}>1. Overview</h2>
          <p style={pStyle}>ApplyAI ("we", "us", or "our") is a job application tracking tool. This Privacy Policy explains what information we collect, how we use it, and how we protect it. By using ApplyAI — including the web app, Chrome extension, or any related services — you agree to this policy.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>2. Information We Collect</h2>
          <p style={pStyle}><strong>Account information:</strong> When you register, we collect your name and email address. If you sign in with Google, we receive your name, email, and profile photo from Google.</p>
          <p style={pStyle}><strong>Job application data:</strong> Information you enter about job applications — company names, roles, status, notes, job descriptions, deadlines, and related details.</p>
          <p style={pStyle}><strong>Contacts:</strong> Names, email addresses, phone numbers, titles, and notes for recruiters or contacts you add.</p>
          <p style={pStyle}><strong>Documents:</strong> Files you upload (resumes, cover letters, etc.) are stored securely to power the AI email assistant feature.</p>
          <p style={pStyle}><strong>AI chat history:</strong> Messages sent to and received from the AI email assistant are stored so your conversation history persists across sessions.</p>
          <p style={pStyle}><strong>Usage data:</strong> We may collect basic, anonymised information about how you use the app to improve the service.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>3. How We Use Your Information</h2>
          <p style={pStyle}>We use your data solely to provide and improve the ApplyAI service:</p>
          <ul style={ulStyle}>
            <li>To authenticate your account and keep it secure</li>
            <li>To store and display your job applications, contacts, and documents</li>
            <li>To generate AI-assisted emails using your resume and job context</li>
            <li>To maintain your AI chat history across sessions</li>
            <li>To improve the product based on usage patterns</li>
          </ul>
          <p style={pStyle}>We do not sell your data. We do not use your data for advertising.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>4. Google Sign-In</h2>
          <p style={pStyle}>If you choose to sign in with Google, we receive your name, email address, and profile picture from Google as part of the authentication process. We use this only to create and identify your account. We do not access your Gmail, Google Drive, or any other Google services.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>5. Chrome Extension</h2>
          <p style={pStyle}>The ApplyAI Chrome extension reads job listing pages you visit (LinkedIn, Indeed, Greenhouse, etc.) to auto-fill the job saving form. This data is sent directly to your ApplyAI account and is not shared with any third party. The extension does not track your browsing history.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>6. Data Storage and Security</h2>
          <p style={pStyle}>Your data is stored in a secure PostgreSQL database hosted on Supabase. We use industry-standard security practices including encrypted connections (HTTPS/TLS) and hashed passwords. We do not store plain-text passwords.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>7. Third-Party Services</h2>
          <p style={pStyle}>ApplyAI uses the following third-party services to operate:</p>
          <ul style={ulStyle}>
            <li><strong>Google Identity Services</strong> — for Google Sign-In authentication</li>
            <li><strong>Google Gemini API</strong> — to generate AI email suggestions (your document content and job context are sent to Google's API for this purpose)</li>
            <li><strong>Supabase</strong> — for database hosting</li>
            <li><strong>Render</strong> — for backend hosting</li>
            <li><strong>Vercel</strong> — for frontend hosting</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>8. Data Retention and Deletion</h2>
          <p style={pStyle}>Your data is retained for as long as your account is active. You may delete individual applications, contacts, and documents at any time from within the app. To delete your entire account and all associated data, contact us at the email below.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>9. Your Rights</h2>
          <p style={pStyle}>You have the right to access, correct, or delete any personal data we hold about you. To exercise these rights, contact us directly.</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>10. Changes to This Policy</h2>
          <p style={pStyle}>We may update this Privacy Policy from time to time. If we make significant changes, we will update the "Last updated" date at the top of this page. Continued use of ApplyAI after changes are posted constitutes acceptance of the updated policy.</p>
        </section>

        <section style={{ ...sectionStyle, marginBottom: 0 }}>
          <h2 style={h2Style}>11. Contact</h2>
          <p style={pStyle}>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:chitrashenshah@gmail.com" style={{ color: '#3b82f6' }}>chitrashenshah@gmail.com</a></p>
        </section>

      </div>
    </div>
  );
}

const sectionStyle = { marginBottom: 32 };
const h2Style = { fontSize: '1.05rem', fontWeight: 700, color: '#0f172a', marginBottom: 10 };
const pStyle  = { color: '#374151', lineHeight: 1.7, marginBottom: 10, fontSize: '0.93rem' };
const ulStyle = { color: '#374151', lineHeight: 1.7, paddingLeft: 20, marginBottom: 10, fontSize: '0.93rem' };
